import React from 'react';
import styled from 'styled-components';
import { Button } from '../../components/ui';
import { closeNotification } from './notificationService';
import renderNotification from './renderNotification';

const ActionsSection = styled.div`
  border-top: 1px solid var(--greyscale-dark-white);
  display: flex;
  gap: 30px;
  justify-content: flex-end;
  padding: 10px 20px;
`;

export const renderSuccessNotificationWithRedirect = (message, redirectButtonLabel, redirectPath, navigate) => {
  const handleClickNotificationLink = () => {
    navigate(redirectPath);
    setTimeout(() => {
      closeNotification(message);
    }, 500);
  };

  const actions = (
    <ActionsSection>
      <Button onClick={handleClickNotificationLink} type="link">
        {redirectButtonLabel}
      </Button>
    </ActionsSection>
  );

  const rules = {
    type: 'success',
    duration: 7,
    message,
    description: actions,
    key: message
  };

  return renderNotification(rules);
};
